<template>

  <div class="w-full bg-white rounded-[20px] px-[17px] pt-[10px] mt-[15px]">
    <div class="text-[20px] sm:text-[25px] font-bold text-[#35474B] uppercase"> {{lang === 'en' ? 'Payment Summary' : 'ملخص الدفع'}} </div>
    <div class="flex justify-between items-center">
      <div class="text-[15px] text-[#35474B]">
        <div class="truncate-to-1-line">
          {{lang === 'en' ? 'Basket total (incl. Tax)' : 'إجمالي السلة (شاملة الضريبة)'}}
        </div>
      </div>
      <div class="text-[#35474B] font-bold text-[15px]">
        {{ basketTotal }} {{lang === 'en' ? 'Sar' : '﷼'}}
      </div>
    </div>
    <div class="flex justify-between items-center">
      <div class="text-[15px] text-[#35474B]">
        <div class="truncate-to-1-line">
          {{lang === 'en' ? 'Delivery' : 'توصيل'}}
        </div>
      </div>
      <div class="text-[#35474B] font-bold text-[15px]">
        {{ deliveryPrice }} {{lang === 'en' ? 'Sar' : '﷼'}}
      </div>
    </div>
    <div class="flex justify-between items-center">
      <div class="text-[15px] text-[#35474B]">
        <div class="truncate-to-1-line">
          {{lang === 'en' ? 'Promo-code' : 'الرمز الترويجي'}}
          <span v-if="discount">({{discount.discount}})</span>
          <span v-if="!discount">(N/A)</span>
        </div>
      </div>
      <div class="text-[#35474B] font-bold text-[15px]">
        <span v-if="discount">{{discount.discount}} {{lang === 'en' ? 'Sar' : '﷼'}}</span>
        <span v-if="!discount">N/A</span>
      </div>
    </div>
    <div class="flex justify-between items-start pb-[11.5px]">
      <div class="text-[15px] text-[#35474B]">
        <span class="font-bold"> {{lang === 'en' ? 'Order Total' : 'إجمالي الطلب'}} </span> {{lang === 'en' ? '(incl. Tax)' : '(شاملة الضريبة)'}}
      </div>
      <div class="text-[#C6A798] font-bold text-[23px]" v-if="discount"> {{Number(basketTotal) + Number(deliveryPrice) - Number(discount.discount)}} {{lang === 'en' ? 'Sar' : '﷼'}} </div>
      <div class="text-[#C6A798] font-bold text-[23px]" v-if="!discount"> {{Number(basketTotal) + Number(deliveryPrice)}} {{lang === 'en' ? 'Sar' : '﷼'}} </div>
    </div>
  </div>

</template>

<script>

export default {
  data(){
    return {
      lang: window?.core?.lang,
    }
  },
  props: {
    deliveryPrice: {
      required: true
    },
    basketTotal: {
      required: true
    },
    discount: {
      required: true
    },
  },
  mounted() {

  },
  methods: {

  }
}

</script>